<template>
  <div class="projects">
    <Hero :heading="heading"/>

    <ul class="list">
      <li v-for="project in ProjectStore" :key="project.id">
        <router-link :to="{name: `${project.route}`}" class="link">{{ project.title }}</router-link>
      </li>
    </ul>

    <!-- <hooper :settings="hooperSettings"> 
      <slide v-for="project in ProjectStore" :key="project.id" >
        <Card :projectID="project.id" />
      </slide>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper> -->
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
// import Card from '@/components/Card.vue'
import ProjectStore from '@/stores/ProjectStore.js'
// import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'

export default {
  name: 'Projects',
  components: {
    Hero,
    // Card,
    // Hooper,
    // Slide,
    // HooperPagination
  },
  data() {
    return {
      heading: 'Projects',
      hooperSettings: {},
      ProjectStore: ProjectStore.projects.filter((x) => x.visible)
    }
  },
}
</script>

<style scoped>
/* @import '~hooper/dist/hooper.css'; */

/* .hooper {
  margin: 0 auto;
  height: 55vh;
  width: 70%;
  outline: none;
  margin-top: 0.5em;
} */

/* Mobile L*/
/* @media (max-width: 530px) {
  .hooper {
    min-height: 55vh;
    width: 80%;
  }
} */

/* Mobile S*/
/* @media (max-width: 450px) {
  .hooper {
    width: 100%;
    height: 25em;
  }
} */

.list {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  list-style-type: none;
}

.list li {
  border-top: 1px dashed var(--color-title);
  transition: var(--default-transition);
}

.list li:last-child {
  border-bottom: 1px dashed var(--color-title);
}

.link {
  color: var(--color-title);
  font-family: var(--secondary-ff);
  font-size: var(--fs-2);
  display: block;
  padding: 2rem;
}

.link:hover {
  color: var(--color-accent-1);
}
</style>